import React from 'react';
import MiniRoute from '../common/MiniRoute';
import { useRoutesMap } from '../common/useRoutesMaps';
import { useIsPageHidden } from '../../global/auth/use-hidden-pages/use-hidden-pages';
import { ActivityManagementScreen } from '../../screens/program-manager/activity-management/ActivityManagementScreen';
import { RostersScreenRouter } from '../../screens/program-manager/rosters/RostersScreenRouter';

export const getActivityLeaderSubContentBlock = () => {
  const {
    management: { route, isAuthorized },
  } = useRoutesMap();
  const isPageHidden = useIsPageHidden();

  return [
    !isPageHidden('management.activity-management') && (
      <MiniRoute
        //
        key='activity-management'
        path={`/${route}/activity-management`}
        component={ActivityManagementScreen}
        isAuthorized={isAuthorized}
      />
    ),
    !isPageHidden('management.rosters') && (
      <MiniRoute
        //
        key='rosters'
        path={`/${route}/rosters`}
        component={RostersScreenRouter}
        isAuthorized={isAuthorized}
      />
    ),
  ];
};
